import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import UpdateFolderTreeHeaderButton from '../../../../components/MenuManager/Header/UpdateFolderTreeButton';
import { getMenuButtonIconSrc } from '../../../../utils/menuManager';
import UserAgentUtils from '../../../../utils/userAgent';

interface UpdateFolderTreeHeaderButtonOwnProps {
	icon?: string;
	label?: string;
}

const mapStateToProps = (state: StoreState, ownProps: UpdateFolderTreeHeaderButtonOwnProps) => {
	const {
		driveList: {
			folderTreeUpdate: { isUpdating },
			driveItems,
			resolutions,
		},
		offlineManager: { isPreparingContentStructure, thumbMap },
		galleryInfos: { config },
	} = state;
	const { icon } = ownProps;
	const isOffline = !UserAgentUtils.isOnline();
	const isBusy = isUpdating || isPreparingContentStructure;

	return {
		iconSrc: getMenuButtonIconSrc(icon, driveItems, config, thumbMap, resolutions),
		isOffline,
		isBusy,
	};
};

export default connect(mapStateToProps)(UpdateFolderTreeHeaderButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/UpdateFolderTreeButton/index.tsx